module.exports = __webpack_public_path__ + "static/12-girl-running-3eb9a38229d737e918f00c347c7816cf.png";